import {Overlay, OverlayRef} from '@angular/cdk/overlay';
import {ComponentPortal} from '@angular/cdk/portal';
import {Injectable, ViewContainerRef} from '@angular/core';
import {delay, of, take, tap} from 'rxjs';

import {GlobalLoaderComponent} from 'libs/shared/component/src/lib/global-loader/global-loader.component';

@Injectable({
    providedIn: 'root'
})
export class GlobalLoaderService {
    private loaderOverlayRef: OverlayRef | null = null;

    constructor(private overlay: Overlay) {}

    show(viewContainerRef: ViewContainerRef): void {
        this.loaderOverlayRef = this.overlay.create({
            width: '100vw',
            height: '100vh'
        });
        const componentPortal = new ComponentPortal(GlobalLoaderComponent, viewContainerRef);
        this.loaderOverlayRef.addPanelClass([
            'bg-white',
            'w-100',
            'd-flex',
            'justify-content-center',
            'align-items-center'
        ]);
        this.loaderOverlayRef.attach(componentPortal);
    }

    hide(delayTime = 500): void {
        of(null)
            .pipe(
                take(1),
                delay(delayTime),
                tap(() => {
                    this.loaderOverlayRef?.detach();
                    this.loaderOverlayRef?.dispose();
                })
            )
            .subscribe();
    }
}
